module.exports = __webpack_public_path__ + "static/media/UniversityofChicago.bacf928d.png";